module.exports = __webpack_public_path__ + "static/img/IR showcase.736c9b38.svg";